var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button-edit',{staticClass:"mr-2",attrs:{"id":_vm.model.item.id}}),_c('button-seating-status',{attrs:{"id":_vm.model.item.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }